<h1 mat-dialog-title>Form data won't be saved</h1>

<mat-dialog-content>
	<p>
		Data is not valid and the changes were not saved, are you sure you want to leave?
	</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-stroked-button [mat-dialog-close]="true">
		Yes, leave without saving changes
	</button>
	<button mat-flat-button mat-dialog-close cdkFocusInitial>
		Cancel
	</button>
</mat-dialog-actions>
